import React, { memo } from 'react';
import VirtualList from '@creditflowresearch/uilib/VirtualList';
import useGetPositions from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/useGetPositions';

import FieldRow from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/FormSteps/OptionalData/OptionalDataFieldsList/FieldRow';
import FieldItem from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/FieldItem/FieldItem';

const OptionalDataField = (props) => (
  <FieldItem { ...props }>
    { FieldRow }
  </FieldItem>
);

const OptionalDataFieldsList = () => {
  const { positions } = useGetPositions();

  return (
    <VirtualList
      data={ positions }
      itemKey="localId"
      height={ 600 }
      itemSize={ 46 }
    >
      { OptionalDataField }
    </VirtualList>
  );
};

export default memo(OptionalDataFieldsList);
